import { useCallback, useMemo } from "react";
import { debounce } from "@perxis-auto/shared";
import { useFilterValues } from "../../../features/filterValues/lib/api/hooks/useFilterValues.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "react-router";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import { actions } from "../../../features/filterChoice/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import { selectGroupedFilterItemByKey } from "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { formatGroupedFilterValue } from "../../../features/filterValues/lib/filterValue/formatGroupedFilterValue.js";
const useContainer = (item) => {
  const dispatch = useAppDispatch();
  const filterGridItem = item;
  const { data: filterValuesItem } = useFilterValues();
  const groupedItems = useAppSelector(
    (state) => selectGroupedFilterItemByKey(state, {
      filterKey: filterGridItem.key,
      filterValuesItem
    })
  );
  const handleChange = useCallback(
    (item2, otherGroupedItems) => (value) => {
      var _a;
      const formattedValue = formatGroupedFilterValue(otherGroupedItems)(value);
      dispatch(
        actions.setValues({
          [item2.key]: formattedValue,
          ...(_a = item2.dependents) == null ? void 0 : _a.reduce(
            (acc, dependentFilterKey) => ({
              ...acc,
              [dependentFilterKey]: null
            }),
            {}
          )
        })
      );
    },
    [dispatch]
  );
  const preparedGroupedItems = useMemo(() => {
    if (!(groupedItems == null ? void 0 : groupedItems.length)) {
      return [];
    }
    return groupedItems.map((item2, index, self) => {
      const otherGroupedItems = [...self];
      otherGroupedItems.splice(index, 1);
      return {
        ...item2,
        props: {
          ...item2.props,
          value: item2.value,
          onChange: debounce(handleChange(item2, otherGroupedItems))
        }
      };
    });
  }, [groupedItems, handleChange]);
  const isDependencyFulfilled = !!(preparedGroupedItems == null ? void 0 : preparedGroupedItems.some((item2) => item2.isDependencyFulfilled));
  return {
    isDependencyFulfilled,
    items: preparedGroupedItems
  };
};
export {
  useContainer
};
